import { NavLink } from '@/components/atoms/NavLink/NavLink';

interface SearchButtonProps {
  text: string;
  href?: string;
  onClick?: () => void;
}

export const SearchButton = ({ text, href, onClick }: SearchButtonProps) => {
  return (
    <NavLink
      label={text}
      isButton
      href={href}
      isNoUnderline
      onClick={onClick}
    />
  );
};

export default SearchButton;
